const JsCookies = require('js-cookie');

export const setRecipeCookie = (recipeID, ratingValue) => {
  const recipeConfig = {
    cookieName: recipeID,
    cookieValue: ratingValue,
    expiration: {
      expires: 7, // days
      path: '/',
    },
  };

  // Set Cookie with new generated UUID Random string
  JsCookies.set(recipeConfig.cookieName, recipeConfig.cookieValue, recipeConfig.expiration);
};

export const getRecipeCookie = (recipeID) => {
  const cookieValue = JsCookies.get(recipeID) || 0;
  return parseInt(cookieValue, 10);
};

export default {
  setRecipeCookie,
  getRecipeCookie,
};
